import { z } from "zod";

const UpdateInventoryCategorySchema = z.object({
    name: z.string().min(1, "Name is required"),
});

export { UpdateInventoryCategorySchema };
export type UpdateInventoryCategoryFormData = z.infer<typeof UpdateInventoryCategorySchema>;
